import React, { useState } from 'react';
import unidecode from 'unidecode';
import Popup from '../../UI/Popup';
import './ExportPopup.css';
import api from '../../api';

const ExportPopup = ({ project, onClose }) => {
    const [format, setFormat] = useState('docx');
    const [isExporting, setIsExporting] = useState(false);

    const handleFormatToggle = (selectedFormat) => {
        setFormat(selectedFormat);
    };

    const sanitizeTitle = (title) => {
        let sanitizedTitle = unidecode(title);
        sanitizedTitle = sanitizedTitle.replace(/[^\w\-_\. ]/g, '');
        sanitizedTitle = sanitizedTitle.trim().replace(/\s+/g, '_');
        return sanitizedTitle;
    };

    const handleExport = async () => {
        if (!project.id) return;

        setIsExporting(true);
        try {
            const response = await api.post(
                '/export',
                { project_id: project.id, format: format },
                { responseType: 'blob' }
            );

            const cleanTitle = sanitizeTitle(project.name);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${cleanTitle}.${format}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Erreur lors de l'export : ", error);
        } finally {
            setIsExporting(false);
            onClose();
        }
    };

    return (
        <Popup 
            onClose={onClose}
            title="Select the file type"
        >
            <div className="format-buttons">
                <button
                    className={`format-button ${format === 'txt' ? 'active' : ''}`}
                    onClick={() => handleFormatToggle('txt')}
                >
                    .TXT
                </button>
                <button
                    className={`format-button ${format === 'docx' ? 'active' : ''}`}
                    onClick={() => handleFormatToggle('docx')}
                >
                    .DOCX
                </button>
                <button
                    className={`format-button ${format === 'pdf' ? 'active' : ''}`}
                    onClick={() => handleFormatToggle('pdf')}
                >
                    .PDF
                </button>
            </div>
            <p className="export-description">You can now download your essay in .{format} format</p>
            <div className="popup-buttons">
                <button
                    className="popup-primary-button"
                    onClick={handleExport}
                    disabled={isExporting}
                >
                    {isExporting ? (
                        <>
                            <span className="material-symbols-outlined">hourglass_top</span>
                            Exporting...
                        </>
                    ) : (
                        <>
                            <span className="material-symbols-outlined">download</span>
                            Download file
                        </>
                    )}
                </button>
            </div>
        </Popup>
    );
};

export default ExportPopup;
